import React from 'react';
import PropTypes from 'prop-types';

const LogoPro = ({ style }) => (
  <svg
    width="115"
    height="40"
    viewBox="0 0 115 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g clipPath="url(#clip0_903_945)">
      <rect width="115" height="40" fill="white" />
      <g clipPath="url(#clip1_903_945)">
        <path d="M0 40V0H40.0645V39.9941H0V40Z" fill="#047E2E" />
        <path
          d="M13.5154 24.1804H15.0072L18.0799 28.2866V24.1804H19.4766V30.5296H17.9848L14.9121 26.4175V30.5296H13.5154V24.1804Z"
          fill="white"
        />
        <path
          d="M26.5848 28.5299C26.5848 30.2566 25.2 30.5296 24.3323 30.5296H20.6355V24.1863H24.3264C25.4556 24.1863 26.3649 24.8271 26.3649 26.0317C26.3649 26.6251 25.943 26.9574 25.628 27.1176C26.151 27.3787 26.5848 27.7703 26.5848 28.5358V28.5299ZM21.9906 25.373V26.5717H24.1718C24.5284 26.5717 24.9266 26.4233 24.9266 25.9783C24.9266 25.5333 24.6176 25.373 24.1183 25.373H21.9906ZM25.1525 28.5299C25.1525 27.9187 24.6414 27.7644 24.1481 27.7644H21.9906V29.2775H24.1956C24.5998 29.2775 25.1465 29.1351 25.1465 28.5299H25.1525Z"
          fill="white"
        />
        <path
          d="M33.6337 29.4912C32.9384 30.0905 32.1835 30.6958 30.6977 30.6958C28.7245 30.6839 27.197 29.1589 27.197 27.3432C27.2089 25.474 28.8017 24.0143 30.7215 24.0143C32.3856 24.0143 33.2831 25.0824 33.4019 25.201L32.35 26.2513C32.1241 26.0199 31.6249 25.4918 30.7096 25.4918C29.5922 25.4918 28.6829 26.3285 28.6829 27.355C28.6829 28.251 29.4555 29.2183 30.7036 29.2183C31.6962 29.2183 32.0647 28.8919 32.6768 28.3816L33.6397 29.4971L33.6337 29.4912Z"
          fill="white"
        />
        <path
          d="M12.8793 29.4912C12.184 30.0905 11.4291 30.6958 9.94329 30.6958C7.97008 30.6839 6.44263 29.1589 6.44263 27.3432C6.45451 25.474 8.04735 24.0143 9.96707 24.0143C11.6312 24.0143 12.5287 25.0824 12.6475 25.201L11.5956 26.2513C11.3697 26.0199 10.8705 25.4918 9.95518 25.4918C8.83782 25.4918 7.92848 26.3285 7.92848 27.355C7.92848 28.251 8.70112 29.2183 9.94924 29.2183C10.9418 29.2183 11.3103 28.8919 11.9224 28.3816L12.8853 29.4971L12.8793 29.4912Z"
          fill="white"
        />
        <path
          d="M24.9504 12.5619L21.6281 20.1394L20.6771 13.5529C20.5583 12.6568 22.0798 12.105 22.0798 12.105C21.9371 11.7964 21.4557 11.8024 21.4557 11.8024H20.4216C20.2551 10.1824 21.7291 9.00161 23.3219 9.36357C24.8851 9.71367 25.4497 11.4107 24.9445 12.556L24.9504 12.5619Z"
          fill="white"
        />
        <path
          d="M18.7813 22.5901L12.303 18.2821C10.6567 17.1844 9.02222 18.3059 8.6775 19.463C8.16637 21.1719 9.3075 22.596 11.1024 22.596H18.7813V22.5901Z"
          fill="white"
        />
        <path
          d="M19.6311 11.9092C19.8688 10.2359 18.3711 8.99569 16.7426 9.36359C15.1795 9.71369 14.6149 11.4108 15.1201 12.556L18.4424 20.1335L19.6311 11.9033V11.9092Z"
          fill="white"
        />
        <path
          d="M18.1751 21.3855L14.9894 14.1284C14.2406 12.4432 12.2674 12.2356 11.1738 13.2206C10.4071 13.9148 9.80679 15.8077 11.5304 16.9589L18.1811 21.3855H18.1751Z"
          fill="white"
        />
        <path
          d="M28.9682 22.5901C30.7631 22.5901 31.8983 21.1659 31.3931 19.457C31.0484 18.2999 29.4199 17.1784 27.7676 18.2762L21.2893 22.5841H28.9682V22.5901Z"
          fill="white"
        />
        <path
          d="M28.5463 16.9589C30.264 15.8137 29.6696 13.9208 28.9029 13.2206C27.8094 12.2356 25.8361 12.4432 25.0873 14.1284L21.9016 21.3855L28.5523 16.9589H28.5463Z"
          fill="white"
        />
        <path d="M115 0H42.2903V40H115V0Z" fill="#047E2E" />
        <path
          d="M55.03 12.2415H61.1517C64.7891 12.2415 67.0535 14.3005 67.0535 17.4276V17.4751C67.0535 20.9523 64.2601 22.7681 60.8427 22.7681H57.7581V27.7525H55.03V12.2415ZM60.9318 20.3055C62.9942 20.3055 64.2839 19.1544 64.2839 17.5344V17.4929C64.2839 15.6771 62.9764 14.7218 60.9318 14.7218H57.7581V20.3055H60.9318Z"
          fill="white"
        />
        <path
          d="M70.5186 12.2415H77.4426C79.398 12.2415 80.9255 12.817 81.924 13.7902C82.7441 14.6328 83.2137 15.784 83.2137 17.1369V17.1843C83.2137 19.73 81.6803 21.2609 79.5288 21.8839L83.7248 27.7525H80.4856L76.67 22.3468H73.2525V27.7525H70.5245V12.2415H70.5186ZM77.2406 19.9317C79.1959 19.9317 80.4381 18.9111 80.4381 17.3386V17.2912C80.4381 15.6297 79.2375 14.7218 77.2227 14.7218H73.2466V19.9317H77.2406Z"
          fill="white"
        />
        <path
          d="M85.5376 20.0445V19.997C85.5376 15.6297 88.9135 11.9745 93.6801 11.9745C98.4467 11.9745 101.781 15.5882 101.781 19.9496V19.9911C101.781 24.3584 98.4051 28.0136 93.6385 28.0136C88.8719 28.0136 85.5376 24.3999 85.5376 20.0386V20.0445ZM98.9222 20.0445V19.997C98.9222 16.9826 96.7231 14.4786 93.6385 14.4786C90.5538 14.4786 88.4023 16.9352 88.4023 19.9496V19.9911C88.4023 23.0055 90.6014 25.4858 93.686 25.4858C96.7706 25.4858 98.9222 23.047 98.9222 20.0326V20.0445Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_903_945">
        <rect width="115" height="40" fill="white" />
      </clipPath>
      <clipPath id="clip1_903_945">
        <rect width="115" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default LogoPro;

LogoPro.propTypes = {
  style: PropTypes.shape(PropTypes.CSSProperties),
};

LogoPro.defaultProps = {
  style: {},
};
